import React from 'react';
import { NumericFormat, OnValueChange } from 'react-number-format';

interface MoneyInputProps {
  value: number;
  customInput: React.ComponentType;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onValueChange?: OnValueChange;
  inputProps?: any;
}

const MoneyInput = ({ value, customInput, onChange, onValueChange, inputProps, ...rest }: MoneyInputProps) => (
  <NumericFormat
    aria-labelledby="money-input"
    value={value}
    prefix={'$'}
    thousandSeparator=","
    decimalSeparator="."
    decimalScale={2}
    onChange={onChange}
    onValueChange={onValueChange}
    customInput={customInput}
    {...inputProps}
    {...rest}
  />
);

export default MoneyInput;
